import React from 'react';
import {HashRouter as Router, Route, Routes} from 'react-router-dom';
import styled, {ThemeProvider} from 'styled-components';
import GlobalStyle from './styles/GlobalStyle';
import theme from './styles/theme';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Portfolio from "./pages/Portfolio";
import Class from "./pages/Class";
import Shop from "./pages/Shop";
import Rental from "./pages/Rental";

const AppContainer = styled.div`
    max-width: 1200px;
    padding: 0 20px;
    margin: 8rem auto;

    @media (max-width: ${props => props.theme.breakpoints.mobile}) {
        margin-top: 2.8rem;
    }
`;

function App() {
    return (
        <Router>
            <ThemeProvider theme={theme}>
                <GlobalStyle/>
                <ScrollToTop/>
                <AppContainer>
                    <Header/>
                    <Routes>
                        <Route path="/" element={<Home/>}/>
                        <Route path="/about" element={<About/>}/>
                        <Route path="/portfolio" element={<Portfolio/>}/>
                        <Route path="/class" element={<Class/>}/>
                        <Route path="/shop" element={<Shop/>}/>
                        <Route path="/shop/:tab" element={<Shop />} />
                        <Route path="/rental" element={<Rental/>}/>
                        <Route path="/rental/:tab" element={<Rental/>}/>
                        <Route path="/contact" element={<Contact/>}/>
                    </Routes>
                    <Footer/>
                </AppContainer>
            </ThemeProvider>
        </Router>
    );
}

export default App;